import { TextOnHoverWhenAdjust } from "../../newLayout/page/ToolTip/ToolTip";

/**
 * Extra Facility Costing list cells for quantity bands.
 * @param {{order: Object, columnHeaderWidth: Object, formattedAmount: Function}} args
 * @return {Object}
 */
export const facilityCostingBandListCells = ({
  order,
  columnHeaderWidth,
  formattedAmount,
}) => {
  const { from_qty, price, to_qty } = order;
  const toQtyText =
    to_qty === "max" || String(to_qty).startsWith("<")
      ? to_qty
      : formattedAmount?.(to_qty) || to_qty;

  return {
    "FROM QUANTITY": (
      <TextOnHoverWhenAdjust
        key="from qty hovered"
        text={from_qty === "" || from_qty == null ? "" : formattedAmount?.(from_qty) || from_qty}
        widthOfElement={columnHeaderWidth["from quantity"] || 100}
        textAlign="right"
      />
    ),
    "TO QUANTITY": (
      <TextOnHoverWhenAdjust
        key="to qty hovered"
        text={to_qty === "" || to_qty == null ? "" : toQtyText}
        widthOfElement={columnHeaderWidth["to quantity"] || 100}
        textAlign="right"
      />
    ),
    PRICE: (
      <TextOnHoverWhenAdjust
        key="price hovered"
        text={price === "" || price == null ? "" : formattedAmount?.(price) || price}
        widthOfElement={columnHeaderWidth["price"] || 100}
        textAlign="right"
      />
    ),
  };
};
